module.exports = __webpack_public_path__ + "static/media/eng-popup-step1.6e1ffef0.png";